import { render } from "./Tabbar.vue?vue&type=template&id=0c1a4deb"
import script from "./Tabbar.vue?vue&type=script&lang=js"
export * from "./Tabbar.vue?vue&type=script&lang=js"

import "./Tabbar.vue?vue&type=style&index=0&id=0c1a4deb&lang=css"

import exportComponent from "/Users/hlw/Documents/HBuilderProjects/menhu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__